import {Vue} from '~/addiesaas'
import ReCorePageCardCheckBalance from './check-balance'
Vue.component(ReCorePageCardCheckBalance.name, ReCorePageCardCheckBalance)

export default {
  ReCorePageCardCheckBalance,
}
